import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { Alert, ButtonToolbar, Collapse } from 'reactstrap';
import SmartCard from '../../../shared/components/SmartCard';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import Select from '../../../shared/components/form/Select';
import SmartButton from '../../../shared/components/SmartButton';
import PresenceGridMaintenance from '../../../shared/components/PresenceGridMaintenance';

const AttendanceStudentForm = (props) => {
  const {
    t,
    handleSubmit,
    toggleFullScreen,
    coursesData,
    dispatch,
    loadAttendanceGrid,
    attendanceWrapper,
    notificationAlert,
  } = props;

  const [selectedCourse, setSelectedCourse] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [formFilter, setFormFilter] = useState({ enableFilter: false });

  const clearSubjectFiled = () => {
    dispatch(change('AttendanceStudentForm', 'subject', null));
    setSubjects([]);
  };

  const clearFields = () => {
    dispatch(change('AttendanceStudentForm', 'schoolClass', null));
    dispatch(change('AttendanceStudentForm', 'cycle', null));
    clearSubjectFiled();
  };

  const checkEnableFilter = (formFilterValues) => {
    const updatedFormFilter = formFilterValues;
    updatedFormFilter.enableFilter = !!(
      formFilterValues.courseStep &&
      formFilterValues.schoolClass &&
      formFilterValues.subject &&
      formFilterValues.cycle
    );
    setFormFilter(updatedFormFilter);
  };

  const onFormFilterChange = (field, value) => {
    const updatedFormFilter = { ...formFilter };
    updatedFormFilter[field] = value;
    checkEnableFilter(updatedFormFilter);
  };

  const changeSchoolClassesData = (value) => {
    setSelectedCourse(value);
    setSchoolClasses(value.schoolClass);
    setCycles(value.cycles);
    clearFields();
    onFormFilterChange('courseStep', value);
  };

  const changeSetSubjectsBySchoolClass = (value) => {
    if (value) {
      const subjectsBySchoolClass = selectedCourse.subjects.filter(
        (subject) => subject.classId === value.id
      );
      setSubjects(subjectsBySchoolClass);
    } else {
      clearSubjectFiled();
    }
    onFormFilterChange('schoolClass', value);
  };

  useEffect(() => {
    dispatch(
      change('AttendanceStudentForm', 'attendanceWrapper', attendanceWrapper)
    );
  }, [attendanceWrapper]);

  return (
    <SmartCard>
      <form className="form" onSubmit={handleSubmit}>
        <Collapse isOpen={notificationAlert.status} className="w-100">
          <Alert className="text-center" color={notificationAlert.color}>
            {t(notificationAlert.message)}
          </Alert>
        </Collapse>
        <div className="form__form-group--4_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.course')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="courseStep"
                component={SelectVirtualized}
                clearable={false}
                options={coursesData.map((item) => ({
                  ...item,
                  label: item.courseStep.label,
                  value: item.courseStep.value,
                }))}
                onChange={(value) => changeSchoolClassesData(value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.school-class')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="schoolClass"
                component={Select}
                options={schoolClasses}
                onChange={changeSetSubjectsBySchoolClass}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.discipline')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="subject"
                component={Select}
                options={subjects}
                onChange={(value) => onFormFilterChange('subject', value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.cycle')}</span>
            <div className="form_form-group-field">
              <Field
                name="cycle"
                component={Select}
                options={cycles}
                onChange={(value) => onFormFilterChange('cycle', value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <ButtonToolbar className="filter-button">
            <SmartButton
              label={t('general.filter')}
              color="success"
              disabled={!formFilter.enableFilter}
              onClick={() => loadAttendanceGrid(formFilter)}
            />
          </ButtonToolbar>
        </div>
        <div className="form__form-group">
          <PresenceGridMaintenance
            change={change}
            attendanceWrapper={attendanceWrapper}
          />
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <SmartButton
            color="primary"
            label={t('general.back')}
            onClick={toggleFullScreen}
          />
          <SmartButton
            color="success"
            disabled={!attendanceWrapper.listCycleClosingAttendanceDate}
            label={t('general.save')}
            type="submit"
          />
        </ButtonToolbar>
      </form>
    </SmartCard>
  );
};

AttendanceStudentForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loadAttendanceGrid: PropTypes.func.isRequired,
  toggleFullScreen: PropTypes.func.isRequired,
  coursesData: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  attendanceWrapper: PropTypes.shape(PropTypes.shape).isRequired,
  notificationAlert: PropTypes.shape(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'AttendanceStudentForm',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(AttendanceStudentForm));
